import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {InvoiceLayout} from '../Models/InvoiceLayout';
import {map, catchError} from 'rxjs/operators';

@Injectable()
export class InvoiceLayoutService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getLayoutList(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/invoice-layout/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getActiveLayoutList(isCredit: boolean, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/invoice-layout/?isCredit=' + isCredit)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/invoice-layout/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public delete(id, scope = 'backoffice') {
    return this.http.delete(environment.apiUrl + '/' + scope + '/invoice-layout/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getInvoiceLayout(id, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/invoice-layout/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public previewInvoiceLayout(invoiceLayout: InvoiceLayout, scope = 'backoffice') {
    return this.http.post(environment.apiUrl + '/' + scope + '/invoice-layout/preview/', invoiceLayout, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp)),
      catchError(res => this.helper.catchError(res))
    );
  }

  manageLayout(invoiceLayout: InvoiceLayout, isEdit: boolean, id: number, scope = 'backoffice') {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/' + scope + '/invoice-layout/' + id, invoiceLayout)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/' + scope + '/invoice-layout/', invoiceLayout)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  removeImage(fileId, id) {
    return this.http.delete(environment.apiUrl + '/backoffice/invoice-layout/' + id + '/remove-image/' + fileId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
